import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})
export class PopularCoursesMarketingTagService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,
                private fileUploadService: UploadService) {
        super(http, alertService, globalService);
    }


    create(id, data): Observable<any> {
        return this.postRequest(AppUrl.POPULAR_COURSE_MARKETING_TAG(id), data);
    }

    detail(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.POPULAR_COURSE_MARKETING_TAG(id));
    }

    update( id, data): Observable<any> {
        return this.putRequest(AppUrl.POPULAR_COURSE_MARKETING_TAG( id), data);
    }

    get(id, data ): Observable<any> {
        return this.getRequest(AppUrl.POPULAR_COURSE_MARKETING_TAG(id), data);
    }

    fileUpload(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
    }

    fileUploadAdmin(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD_ADMIN(), params, event);
    }

    delete(id): Observable<any> {
        return this.deleteRequest(AppUrl.POPULAR_COURSE_MARKETING_TAG(id));
    }
}
